import { Component, OnInit, Input, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { API_ENDPOINTS } from 'src/app/core/constants/api-endpoints.constant';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdvertisementService } from 'src/app/core/services/advertisement.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { Router, NavigationExtras } from '@angular/router';
import { RenewContentComponent } from 'src/app/components/private-library/renew-content/renew-content.component';
declare const Hls: any;
// declare const amp: any;
declare const videojs: any;
@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.scss'],
})
export class VideoPlayerComponent implements OnInit, OnDestroy {
  url;
  thumbnail;
  content;
  seekbarTracker: any = {
    duration: 0,
    time: 0,
    seekPercent: 0,
    hasDVR: false,
  };
  player: any;

  playindex = 0;
  materialAd = [];
  azurePlaylist = {};
  playlist = [];
  imagePath = API_ENDPOINTS.BASE_URL;
  isAdPlaying = false;
  materialAdPlaying;
  objectURL = [];
  userData;
  isOneContentAvailable: boolean = false;
  @ViewChild('previousButton', { static: true }) public previousButton: ElementRef;
  @ViewChild('nextButton', { static: true }) public nextButton: ElementRef;
  constructor(private activeModal: NgbActiveModal,
    private authService: AuthService,
    private _advertisementService: AdvertisementService,
    private modalService: NgbModal,
    private router: Router,
  ) { }
  @Input() public collection: any;
  ngOnInit() {
    this.userData = this.authService.getCurrentUser();
    if (this.collection && this.collection.contents) {
      this.playlist = this.collection.contents;
      if (this.playlist) {
        let playable = this.playlist.filter((item) => {
          return !item.grace_and_grayed && ((item.visibility != 'grayed' && item.content_relationship && item.content_relationship.visibility != 'disable') || this.userData.user.id === item.user_id) || (this.userData.user.id !== item.user_id && item.tokens > 0 && item.content_relationship && item.content_relationship.visibility != 'disable');
        });
        if (playable && playable.length == 1) {
          this.isOneContentAvailable = true;
        }
      }
    }
  }
  setContentClick(index) {
    if (this.playlist[index].grace_and_grayed || (this.playlist[index].visibility == 'grayed' && this.userData.user.id !== this.playlist[index].user_id && this.playlist[index].tokens <= 0) || this.playlist[index].content_relationship.visibility == 'disable' || (this.playlist[index].paid_library_subscription_expired && !this.playlist[index].purchase_content_before_paid_lib_subscribe && this.playlist[index].tokens > 0) || this.playlist[index].content_deteled_by_owner) {

      if ((this.playlist[index].paid_library_subscription_expired && !this.playlist[index].purchase_content_before_paid_lib_subscribe && this.playlist[index].tokens > 0 && !this.playlist[index].user_plan_expired) && this.playlist[index].user.verification && this.playlist[index].user.verification.is_verified != 'rejected' && this.playlist[index].creator_library_type == 'public') {
        const modalRef = this.modalService.open(RenewContentComponent, { centered: true });
        modalRef.componentInstance.currentUser = this.playlist[index].user;
        modalRef.result.then((result) => {
          if (result == 'renew-subscription') {
            this.closeDialog();
            const navigationExtras: NavigationExtras = {
              queryParams: {
                source: 'subscriptionModal',
                user_id: this.playlist[index].user.id
              }
            };
            this.router.navigate(['/other-profile', this.playlist[index].user.id], navigationExtras);
          }
          if (result == 'buy-individual') {
            this.closeDialog();
            const navExtras: NavigationExtras = {
              queryParams: {
                buy_individual: "true",
              }
            }
            this.router.navigate(['/material-detail-page', this.playlist[index].id], navExtras);
          }
        });
      }
      return;
    }
    this.setContent(index);
  }
  setContent(index, init?) {
    if (this.playlist[index].grace_and_grayed || (this.playlist[index].visibility == 'grayed' && this.userData.user.id !== this.playlist[index].user_id && this.playlist[index].tokens <= 0) || this.playlist[index].content_relationship.visibility == 'disable' || (this.playlist[index].paid_library_subscription_expired && !this.playlist[index].purchase_content_before_paid_lib_subscribe && this.playlist[index].tokens > 0) || this.playlist[index].content_deteled_by_owner) {
      this.playindex = index;
      this.playNext();
      return;
    }
    this.playindex = index;
    this.content = this.playlist[index];
    // this.azureMedia();
    // AD code comment start
    if (this.materialAd && this.materialAd[this.content.id] && this.materialAd[this.content.id] != false) {
      if (this.content.content_type == 'audio') {
        this.materialAdPlaying = [this.materialAd[this.content.id]];
      } else {
        this.materialAdPlaying = this.materialAd[this.content.id];
      }
      this.isAdPlaying = true;

      if (this.materialAdPlaying[0] && (this.materialAdPlaying[0].label == 'video' || this.materialAdPlaying[0].label == 'audio')) {
        this.azureMediaVast();
      }
    } else {
      this._advertisementService.loadMaterialAds(this.content.id).subscribe(
        (response: any) => {
          if (response.success && response.data.advertisement) {
            this.materialAd[this.content.id] = response.data.advertisement;
            if (this.content.content_type == 'audio') {
              this.materialAdPlaying = [this.materialAd[this.content.id]];
            } else {
              this.materialAdPlaying = this.materialAd[this.content.id];
            }

            this.isAdPlaying = true;
            if (this.materialAdPlaying[0] && (this.materialAdPlaying[0].label == 'video' || this.materialAdPlaying[0].label == 'audio')) {
              this.azureMediaVast();
            }
          }
          else {
            this.materialAd[this.content.id] = false;
            this.azureMedia();
          }
        },
        (error: any) => {
          this.materialAd[this.content.id] = false;
          this.azureMedia();
        }
      )
    }
    // AD code comment end
    // if (!init) {
    //   this.azureMedia();
    // }

    // const thumbnail = (this.content.links_cloud && this.content.links_cloud.thumbnail) ? this.content.links_cloud.thumbnail : API_ENDPOINTS.BASE_URL + this.content.thumb;
    // this.url = this.content.link;
    // this.thumbnail = thumbnail;

    // if (this.playlist.length) {
    //   let clip = [];
    //   let index = 1;
    //   this.playlist.forEach(element => {

    //     let source = [];
    //     Object.entries(element.links_cloud.dash).forEach(([key, value]) => {
    //       let obj = {};
    //       obj = {
    //         src: value,
    //         type: "application/vnd.ms-sstr+xml"
    //       };
    //       source.push(obj)
    //     });
    //     source.push({
    //       src: element.links_cloud.manifest,
    //       type: "application/vnd.ms-sstr+xml"
    //     });

    //     clip.push({
    //       isAd: (index == 2) ? true : false,
    //       name: element.out_line,
    //       offset: 0,
    //       parent: {
    //         source: source,
    //         name: element.out_line
    //       }
    //     })
    //     index = index + 1;
    //   });
    //   this.azurePlaylist = {
    //     clips: clip,
    //     name: 'My Video playlist'
    //   }
    // }


  }

  async ngAfterViewInit() {
    // const source = 'https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8';
    // const video: any = document.getElementById('sxmvideo');
    // this.azureMedia();
    this.setContent(this.playindex, true);
    // this.azureMedia();
    // // For more options see: https://github.com/sampotts/plyr/#options
    // // captions.update is required for captions to work with hls.js
    // this.player = new Plyr(video, { captions: { active: true, update: true, language: 'en' } });
    // if (!Hls.isSupported() || !this.isHls) {
    //   video.src = this.url;
    // } else {

    //   var config = {
    //     autoStartLoad: true,
    //     startPosition: -1,
    //     debug: false,
    //     capLevelOnFPSDrop: true,
    //     capLevelToPlayerSize: true,
    //     defaultAudioCodec: undefined,
    //     initialLiveManifestSize: 1,
    //     maxBufferLength: 30,
    //     maxMaxBufferLength: 600,
    //     maxBufferSize: 60 * 1000 * 1000,
    //     maxBufferHole: 0.5,
    //     lowBufferWatchdogPeriod: 0.5,
    //     highBufferWatchdogPeriod: 3,
    //     nudgeOffset: 0.1,
    //     nudgeMaxRetry: 3,
    //     maxFragLookUpTolerance: 0.25,
    //     liveSyncDurationCount: 3,
    //     liveMaxLatencyDurationCount: Infinity,
    //     enableWorker: true,
    //     enableSoftwareAES: true,
    //     manifestLoadingTimeOut: 10000,
    //     manifestLoadingMaxRetry: 1,
    //     manifestLoadingRetryDelay: 1000,
    //     manifestLoadingMaxRetryTimeout: 64000,
    //     startLevel: undefined,
    //     levelLoadingTimeOut: 10000,
    //     levelLoadingMaxRetry: 4,
    //     levelLoadingRetryDelay: 1000,
    //     levelLoadingMaxRetryTimeout: 64000,
    //     fragLoadingTimeOut: 20000,
    //     fragLoadingMaxRetry: 6,
    //     fragLoadingRetryDelay: 1000,
    //     fragLoadingMaxRetryTimeout: 64000,
    //     startFragPrefetch: false,
    //     fpsDroppedMonitoringPeriod: 5000,
    //     fpsDroppedMonitoringThreshold: 0.2,
    //     appendErrorMaxRetry: 3,
    //     enableWebVTT: true,
    //     enableCEA708Captions: true,
    //     stretchShortVideoTrack: false,
    //     maxAudioFramesDrift: 1,
    //     forceKeyFrameOnDiscontinuity: true,
    //     abrEwmaFastLive: 3.0,
    //     abrEwmaSlowLive: 9.0,
    //     abrEwmaFastVoD: 3.0,
    //     abrEwmaSlowVoD: 9.0,
    //     abrEwmaDefaultEstimate: 500000,
    //     abrBandWidthFactor: 0.95,
    //     abrBandWidthUpFactor: 0.7,
    //     abrMaxWithRealBitrate: false,
    //     maxStarvationDelay: 4,
    //     maxLoadingDelay: 4,
    //     minAutoBitrate: 0,
    //     emeEnabled: false,
    //     widevineLicenseUrl: undefined,
    //     // requestMediaKeySystemAccessFunc: requestMediaKeySystemAccess
    //   };

    //   // For more Hls.js options, see https://github.com/dailymotion/hls.js
    //   this.hls = new Hls(config);


    // this.player.on('ended', (event) => {
    //   if (this.playlist[this.playindex + 1]) {
    //     this.playindex = this.playindex + 1;
    //     this.player.destroy();
    //     this.setContent(this.playindex);
    //     this.ngAfterViewInit();
    //   } else {
    //     this.playindex = 0;
    //     this.player.destroy();
    //     this.setContent(this.playindex);
    //     this.ngAfterViewInit();
    //   }
    // });

  }

  azureMedia() {
    if (this.player) {
      // this.player.pause();
      // AD code comment start
      this.player.dispose();
      this.player = null;
      document.getElementById('video-player-wrapper').innerHTML = '<video id="my-player1" style="width: auto;height: auto;padding-bottom: 56.522%;" class="video-js vjs-default-skin" tabindex="0" height="300"> <p class="vjs-no-js"> To view this video please enable JavaScript, and consider upgrading to a web browser that supports HTML5 video </p> </video>';
      document.getElementById('audio-player-wrapper').innerHTML = '<audio id="my-player2" style="width: auto;height: auto;padding-bottom: 56.522%;" class="video-js vjs-default-skin" tabindex="-1" height="300"> </audio>';
      // AD code comment start
    }

    setTimeout(() => {
      if (this.content && this.content.links_cloud && this.content.links_cloud.dash) {
        const that = this;
        if (!this.player) {

          this.player = videojs(((this.content.content_type == 'audio') ? 'my-player2' : 'my-player1'), { /* Options */
            techOrder: ["azureHtml5JS", "flashSS", "html5FairPlayHLS", "silverlightSS", "html5"],
            "nativeControlsForTouch": false,
            controlBar: {
              volumePanel: { 
                inline: false,
                vertical: true
               },
              playToggle: { replay: false }
            },
            logo: { enabled: false },
            autoplay: true,
            controls: true,
            width: "640",
            height: "400",

            // plugins: {
            //   azureButtons: {

            //   }
            // }
          }, function () {
            setTimeout(() => {
              this.controlBar.el_.querySelector('.vjs-controlbaricons-left').appendChild(that.previousButton.nativeElement);
              this.controlBar.el_.querySelector('.vjs-controlbaricons-left').appendChild(that.nextButton.nativeElement);
            }, 10);
            this.addEventListener('ended', function () {
              that.playNext();
            })
          });
        }

        let srcArray = [];
        Object.entries(this.content.links_cloud.dash).forEach(([key, value]) => {
          let obj = {};
          obj = {
            src: value,
            type: "application/vnd.ms-sstr+xml"
          }
          srcArray.push(obj)
        });
        srcArray.push({
          src: this.content.links_cloud.manifest,
          type: "application/vnd.ms-sstr+xml"
        })

        if (this.content.thumb) {
          this.player.poster(this.imagePath + this.content.thumb);
        }

        this.player.src(srcArray);
      }
    }, 0);
  }
  closeDialog() {
    // if (this.content && this.content.links_cloud)
    //   this.player.dispose();

    this.activeModal.close();
  }



  playNext() {
    // this.player.playNext();
    // console.log("current playing", this.playindex);
    // console.log("Next", this.playindex + 1);
    if (this.playlist[this.playindex + 1]) {
      this.setContent(this.playindex + 1);
      // this.ngAfterViewInit();
    } else {
      // this.playindex = 0;
      // this.setContent(this.playindex);
    }
  }

  playPrevious() {
    if (this.playlist[this.playindex - 1]) {
      this.setContent(this.playindex - 1);
    } else {
      // this.playindex = this.playlist.length - 1;
      // this.setContent(this.playindex);
    }
  }

  azureMediaVast() {
    if (this.player) {
      this.player.dispose();
      this.player = null;
      document.getElementById('video-player-wrapper').innerHTML = '<video id="my-player1" style="width: auto;height: auto;padding-bottom: 56.522%;" class="video-js vjs-default-skin" tabindex="0" height="300"> <p class="vjs-no-js"> To view this video please enable JavaScript, and consider upgrading to a web browser that supports HTML5 video </p> </video>';
      document.getElementById('audio-player-wrapper').innerHTML = '<audio id="my-player2" style="width: auto;height: auto;padding-bottom: 56.522%;" class="video-js vjs-default-skin" tabindex="-1" height="300"> </audio>';
    }
    // debugger
    if (this.content && this.content.links_cloud && this.content.links_cloud.dash) {
      var that = this;
      let srcArray = [];


      Object.entries(this.content.links_cloud.dash).forEach(([key, value]) => {
        let obj = {};
        obj = {
          src: value,
          type: "application/vnd.ms-sstr+xml"
        }
        srcArray.push(obj);
      });
      srcArray.push({
        src: this.content.links_cloud.manifest,
        type: "application/vnd.ms-sstr+xml"
      })
      let ads = this.prepareAdObject();
      ads['mainProgram'] = {
        source: srcArray,
      };
      // if(this.player){
      //   this.player.src(srcArray);
      // }
      setTimeout(() => {
        this.player = videojs(((this.content.content_type == 'audio') ? 'my-player2' : 'my-player1'), { /* Options */
          techOrder: ["azureHtml5JS", "flashSS", "html5FairPlayHLS", "silverlightSS", "html5"],
          "nativeControlsForTouch": false,
          controlBar: {
            volumePanel: { 
              inline: false,
              vertical: true
             },
            playToggle: { replay: false }
          },
          logo: { enabled: false },
          autoplay: true,
          controls: true,
          width: "640",
          height: "400",
          // ampAds: ads
        }, function () {
          // console.log('Good to go!');
          setTimeout(() => {
            this.controlBar.el_.querySelector('.vjs-controlbaricons-left').appendChild(that.previousButton.nativeElement);
            this.controlBar.el_.querySelector('.vjs-controlbaricons-left').appendChild(that.nextButton.nativeElement);
          }, 10);
          this.addEventListener('ended', function () {
            that.playNext();
          })
        });
        this.player.title = this.content.out_line ? this.content.out_line : this.content.name
        if (this.content.thumb) {
          this.player.poster(this.imagePath + this.content.thumb);
        }
      }, 0);
    }
  }

  prepareAdObject() {
    if (this.objectURL.length) {
      this.objectURL.forEach((element) => {
        window.URL.revokeObjectURL(element);
      });
    }
    let preRoll = {
      sourceUri: '',
      options:
      {
        skipAd:
        {
          enabled: true,
          offset: 5
        }
      }
    }

    // let postRoll = {
    //   sourceUri: '',
    //   options:
    //   {
    //     skipAd:
    //     {
    //       enabled: true,
    //       offset: 5
    //     }
    //   }
    // }
    let ads = {
      midRoll: []
    };
    if (this.materialAdPlaying[0]) {
      this.materialAdPlaying.forEach(element => {
        // console.log(element);

        let midRoll = {
          sourceUri: '',
          startTime: 0,
          options:
          {
            skipAd:
            {
              enabled: true,
              offset: 5
            }
          }
        }
        if (this.content.content_type == 'video') {
          if (element.slot && parseInt(element.slot.start_at) == 0 && !element.slot.is_last) {
            // preRoll.sourceUri = this.generateVastString(element);
            midRoll.sourceUri = this.generateVastString(element);
            midRoll.startTime = 0.5;
            if (parseInt(element.advertisement_length) <= 5) {
              midRoll.options.skipAd.enabled = false;
            }
            ads.midRoll.push(midRoll);
          } else {
            // if (!element.slot.is_last) {
            midRoll.sourceUri = this.generateVastString(element);
            midRoll.startTime = parseFloat(element.slot.start_at);
            if (parseInt(element.advertisement_length) <= 5) {
              midRoll.options.skipAd.enabled = false;
            }
            ads.midRoll.push(midRoll);
            // } else if (element.slot.is_last) {
            // midRoll.sourceUri = this.generateVastString(element);
            // midRoll.startTime = parseInt(element.slot.start_at);
            // if (parseInt(element.advertisement_length) <= 5) {
            //   // postRoll.options.skipAd.enabled = false;
            // }
            // ads.midRoll.push(midRoll);
          }
        } else if (this.content.content_type == 'audio') {
          midRoll.sourceUri = this.generateVastString(element);
          midRoll.startTime = 0.5;
          if (parseInt(element.advertisement_length) <= 5) {
            midRoll.options.skipAd.enabled = false;
          }
          ads.midRoll.push(midRoll);
        }
      });
      if (preRoll.sourceUri) {
        ads['preRoll'] = preRoll;
      }
      // if (postRoll.sourceUri) {
      //   ads['postRoll'] = postRoll;
      // }
      return ads;
    }
  }

  generateVastString(materialAd) {
    const createVast = require('vast-builder');
    const vast3 = createVast.v3();

    vast3.attachAd()
      .attachInLine()
      .addImpression(materialAd.link)
      // .addAdSystem('Society')
      .addAdTitle(materialAd.name)
      .attachCreatives()
      .attachCreative()
      .attachLinear()
      // .attachTrackingEvents()
      // .attachTracking('content', { event: 'start' }).back()
      .addDuration('00:00:00')
      .attachMediaFiles()
      .attachMediaFile(materialAd.image, {
        delivery: 'streaming',
        type: 'video/mp4',
        scalable: 'true'
      })
      .back()
      .attachVideoClicks()
      .addClickThrough(
        materialAd.link, {}
      ).back();
    // .attachStaticResource('ressource_link', { creativeType: 'image/jpeg' })

    const render = vast3.toXml();
    var data = new Blob([render], { type: 'application/xml' });


    this.objectURL.push(data);
    return window.URL.createObjectURL(data);

  }

  change(event) {
    this.materialAdPlaying = null;
    this.isAdPlaying = false;
    this.azureMedia();
  }

  ngOnDestroy() {
    if (this.content && this.content.links_cloud)
      this.player.dispose();

    if (this.objectURL.length) {
      this.objectURL.forEach((element) => {
        window.URL.revokeObjectURL(element);
      });
    }
  }
}
